import { useQueryClient } from '@tanstack/react-query';
import { useDebouncedCallback } from 'use-debounce';

import { ONE_SECOND } from '@air/utilities';

import { useEventSubscription } from '~/hooks/useEventSubscription';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { getCreditStatsKey } from '~/swr-hooks/workspaces/useCreditStats';

export const useHandleWorkspaceCreditsConsumed = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const queryClient = useQueryClient();

  /**
   * If credit consumption events are produced in quick succession, we want to debounce
   * these to avoid unnecessary API calls.
   */
  const [debouncedInvalidate] = useDebouncedCallback((workspaceId: string) => {
    queryClient.invalidateQueries({ queryKey: getCreditStatsKey({ workspaceId }) });
  }, ONE_SECOND);

  useEventSubscription({
    currentWorkspaceId: currentWorkspace?.id,
    event: {
      eventType: 'System.Workspace.Credit.consumed',
    },
    options: {
      onUpdate: ({ data: { workspaceId } }) => {
        debouncedInvalidate(workspaceId);
      },
    },
  });
};
